import { Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

export const ReconciliationSuggestionContent = styled.div`
  display: grid;
  align-items: center;
  grid-template-columns: auto min-content;
  grid-gap: ${Spacing.S8};
`
